export const InsideFifaBackOfficeEndpoints = {
    Players: '/insideFifa/players',
    GenericTables: {
        Files: '/insideFifa/generic-tables/files',
        Configs: '/insideFifa/generic-tables/configs',
        DataFile: '/insideFifa/generic-tables/datafile',
    },
};
